/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsApiErrorResponseSchema } from "./goodLuck/core/DTOs/apiErrorResponseSchema.ts";
import { goodLuckCoreDTOsTokenResponseDtoSchema } from "./goodLuck/core/DTOs/tokenResponseDtoSchema.ts";
import { z } from "zod/v4";

export const getTeamsIdInviteTokenPathParamsSchema = z.object({
  id: z.string(),
});

/**
 * @description OK
 */
export const getTeamsIdInviteToken200Schema = z.lazy(
  () => goodLuckCoreDTOsTokenResponseDtoSchema,
);

/**
 * @description Unauthorized
 */
export const getTeamsIdInviteToken401Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Forbidden
 */
export const getTeamsIdInviteToken403Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Not Found
 */
export const getTeamsIdInviteToken404Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Internal Server Error
 */
export const getTeamsIdInviteToken500Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

export const getTeamsIdInviteTokenQueryResponseSchema =
  getTeamsIdInviteToken200Schema;
